import { PaymentsGetPremiumPayDataRequestData, PaymentsGetPremiumPayDataRequestDto, PaymentsGetPremiumPayDataResponseData, PaymentsGetPremiumPayDataResponseDto } from '@services/dto/payments';
export const paymentsGetPremiumPayDataRequestToDto = (data: PaymentsGetPremiumPayDataRequestData): PaymentsGetPremiumPayDataRequestDto => {
  return {
    paymentMethodId: data.paymentMethodId,
    aggregatorId: data.aggregatorId,
    description: data.description
  };
};
export const paymentsGetPremiumPayDataResponseFromDto = (dto: PaymentsGetPremiumPayDataResponseDto): PaymentsGetPremiumPayDataResponseData => {
  return dto.data;
};